// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCDB3LR0fww2CoBMgFRzA1Uu9u56VixToY",
  authDomain: "chatbot-demo-bebf2.firebaseapp.com",
  projectId: "chatbot-demo-bebf2",
  storageBucket: "chatbot-demo-bebf2.appspot.com",
  messagingSenderId: "650296264085",
  appId: "1:650296264085:web:ed5a1f5a4662b10520a29c",
  measurementId: "G-GNT8DWFNY1"
};

export default firebaseConfig;